"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _staff = require("@/api/staff");
var _role = _interopRequireDefault(require("@/views/permission/role.vue"));
var _StaffModal = _interopRequireDefault(require("./components/StaffModal.vue"));
var _role2 = require("@/types/role");
var _role3 = require("@/api/role");
var StaffPage = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(StaffPage, _Vue);
  var _super = (0, _createSuper2.default)(StaffPage);
  function StaffPage() {
    var _this;
    (0, _classCallCheck2.default)(this, StaffPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "data", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "total", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "query", {
      page: 1,
      limit: 10,
      search: "",
      roleNames: [],
      buildingIds: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "roles", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "staffManagers", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "staffMangerId", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildings", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "avatarDefault", require("@/assets/images/avatar_default.svg"));
    return _this;
  }
  (0, _createClass2.default)(StaffPage, [{
    key: "getStaffManager",
    value: function getStaffManager(row) {
      var find = this.staffManagers.find(function (e) {
        return e.buildings.some(function (building) {
          return building.id == row.id;
        });
      });
      return find === null || find === void 0 ? void 0 : find.name;
    }
  }, {
    key: "fetchRoles",
    value: function () {
      var _fetchRoles = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _role3.roleApi.getRoles();
              case 2:
                res = _context.sent;
                this.roles = res.data;
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetchRoles() {
        return _fetchRoles.apply(this, arguments);
      }
      return fetchRoles;
    }()
  }, {
    key: "handleQuery",
    value: function handleQuery() {
      this.query.page = 1;
      this.fetchData();
    }
  }, {
    key: "handleQueryStaff",
    value: function handleQueryStaff() {
      var _this2 = this;
      this.buildings = [];
      var find = this.staffManagers.find(function (e) {
        return e.id == _this2.staffMangerId;
      });
      if (find) {
        this.buildings = find.buildings;
      }
      this.query.buildingIds = this.buildings.map(function (e) {
        return e.id;
      });
      this.fetchData();
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.$refs.StaffModal.handleCreate();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(staff) {
      this.$refs.StaffModal.handleUpdate(staff);
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
      this.fetchRoles();
      this.fetchStaffManager();
    }
  }, {
    key: "fetchStaffManager",
    value: function () {
      var _fetchStaffManager = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.loading = true;
                _context2.next = 4;
                return _staff.staffApi.findAll({
                  limit: 0,
                  page: 0,
                  roleNames: [_role2.RoleName.Manager]
                });
              case 4:
                res = _context2.sent;
                this.staffManagers = res.data.staffs;
              case 6:
                _context2.prev = 6;
                this.loading = false;
                return _context2.finish(6);
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0,, 6, 9]]);
      }));
      function fetchStaffManager() {
        return _fetchStaffManager.apply(this, arguments);
      }
      return fetchStaffManager;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                this.loading = true;
                _context3.next = 4;
                return _staff.staffApi.findAll(this.query);
              case 4:
                res = _context3.sent;
                this.data = res.data.staffs;
                this.total = res.data.total;
              case 7:
                _context3.prev = 7;
                this.loading = false;
                return _context3.finish(7);
              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0,, 7, 10]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
  return StaffPage;
}(_vuePropertyDecorator.Vue);
StaffPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    Role: _role.default,
    StaffModal: _StaffModal.default
  }
})], StaffPage);
var _default = StaffPage;
exports.default = _default;